import { formatFecha } from "src/views/dataTienda/abonosPasarela/utils/constans/formatFecha";
import { AbonoPasarela } from "../../bussines/entities/AbonoPasarela";
import { datosConciliador, detalleConciliador } from "../types/datosConciliador";

export const mapperAbonosPasarela = (data: AbonoPasarela[]): datosConciliador[] => {
    const grouped = data.reduce((acc: Record<number, datosConciliador>, curr) => {
        const key = curr.idAbono;

        if (!acc[key]) {
            acc[key] = {
                idAbono: curr.idAbono,
                fechaAbono: formatFecha(curr.fechaAbono),
                totalAbono: curr.totalAbono,
                detalles: []
            };
        }

        // Mapeo de la fila hija con validación de nulos
        const nuevoDetalle: detalleConciliador = {
            dniRuc: curr.docIdentidadCliente ?? "-",
            cliente: curr.nombreRazonSocialCliente ?? "-",
            documento: curr.documento || "-",
            montoOperacion: curr.montoOperacion.toFixed(2),
            montoAbono: curr.montoNetoAbonado.toFixed(2),
            comision: curr.comision.toFixed(2),
            fechaPago: formatFecha(curr.fechaEmisionComprobante),
            fechaCobro: formatFecha(curr.fechaOperacion),
            tipoPago: curr.tipoPago ?? "-",
            pdf: curr.urlPdf
        };

        acc[key].detalles.push(nuevoDetalle);

        return acc;
    }, {});

    return Object.values(grouped);
};